<template>
  <div class="centered-container">
    <v-card>
      <v-card-title>{{ $t('account.password.title') }}</v-card-title>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.centered-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>

<script>
export default {
  components: {},
  computed: {},
  mounted() {
    this.$store.dispatch('app/setSection', 'account')
    // Define window title
    this.$store.dispatch(
      'app/setTitle',
      this.$i18n.t('account.password.pageTitle')
    )
  }
}
</script>
